import axios from 'axios'
import config from '../../config'
import { getUserToken } from '../../contexts/Auth'
import { LoginSuccess, MobileRequired, OtpRequired } from './auth.interfaces'
const { authService } = config

export async function lineLogin(
  lineCode: string,
  otpToken?: string,
  email?: string,
): Promise<LoginSuccess | MobileRequired | OtpRequired> {
  try {
    const loginPayload = {
      token: lineCode,
      otpToken: otpToken,
      project: authService.AUTH_PROJECT,
      deviceType: 'WEBSITE',
      callBackUrl: config.social.LINE_CALLBACK_URL,
      ...(email && { email }),
    }
    const loginResponse = await axios.post(
      `${authService.URL}/social-login-v2/line`,
      loginPayload,
      {
        validateStatus(status) {
          return [419, 400, 303].includes(status) || (status >= 200 && status < 300)
        },
      },
    )
    return loginResponse.data
  } catch (error: any) {
    if (error?.response?.data?.message) {
      throw error?.response?.data?.message
    }
    throw error
  }
}

export async function lineLinkAccount(lineCode: string, userId: number): Promise<LoginSuccess> {
  try {
    const linkPayload = {
      lineCode,
      userId,
      project: authService.AUTH_PROJECT,
      deviceType: 'WEBSITE',
      callBackUrl: config.social.LINE_CALLBACK_URL,
    }
    const linkResponse = await axios.post(`${authService.URL}/line-link/link`, linkPayload, {
      validateStatus(status) {
        return [419, 400, 303].includes(status) || (status >= 200 && status < 300)
      },
    })
    return linkResponse.data
  } catch (error: any) {
    if (error?.response?.data?.message) {
      throw error?.response?.data?.message
    }
    throw error
  }
}

export async function checkLineLinkedStatus(
  userId: number,
): Promise<{ hasLineLinked: boolean; lineUserId: string | null }> {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_TS_RESTFUL_API_URL}/api/line/apps/check/user-link-status`,
      {
        params: { userId },
        headers: { Authorization: getUserToken() },
      },
    )
    return response.data
  } catch (error: any) {
    if (error?.response?.data?.error) {
      throw error?.response?.data?.error
    }
    throw error
  }
}

export async function checkUserLineStatus(
  line_user_id: string,
): Promise<{ hasAddedLine: boolean; line_user_id: string }> {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_TS_RESTFUL_API_URL}/api/line/apps/check/user-status`,
      {
        params: { line_user_id },
        headers: { Authorization: getUserToken() },
      },
    )

    return response.data
  } catch (error: any) {
    return { hasAddedLine: false, line_user_id }
  }
}
